/* ================================================================
   Hope Estate — Age Verification Gate
   - Shows popup 10 seconds after page load (first visit only)
   - YES: sets cookie, closes popup
   - NO: redirects to /pages/underage
   - Cookie lasts 30 days (so it doesn't annoy returning visitors)
   ================================================================ */
(function() {
  'use strict';

  var COOKIE_NAME   = 'he_age_verified';
  var COOKIE_DAYS   = 30;
  var DELAY_MS      = 10000; // 10 seconds
  var UNDERAGE_URL  = '/pages/underage';
  var SKIP_PATHS    = [UNDERAGE_URL, '/password'];

  // Don't show on underage or password pages
  if (SKIP_PATHS.some(function(p) { return window.location.pathname.indexOf(p) !== -1; })) return;

  // Check cookie
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }
  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax; Secure';
  }

  if (getCookie(COOKIE_NAME) === 'yes') return; // already verified

  function buildGate() {
    var overlay = document.createElement('div');
    overlay.id = 'he-age-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Age Verification');
    overlay.innerHTML = '\
      <div class="he-age__box">\
        <div class="he-age__logo-wrap">' +
          (document.querySelector('.header__heading-logo') ?
            '<img src="' + (document.querySelector('.header__heading-logo').src || '') + '" alt="Hope Estate" class="he-age__logo">' : '<div class="he-age__logo-text">HOPE ESTATE</div>') + '\
        </div>\
        <p class="he-age__eyebrow">Pokolbin &middot; Hunter Valley</p>\
        <h2 class="he-age__title">Welcome to Hope Estate</h2>\
        <p class="he-age__sub">This website contains alcohol. You must be 18 or over to enter.</p>\
        <p class="he-age__question">Are you 18 years of age or older?</p>\
        <div class="he-age__btns">\
          <button id="he-age-yes" class="he-age__btn he-age__btn--yes">Yes, I am 18+</button>\
          <button id="he-age-no"  class="he-age__btn he-age__btn--no">No</button>\
        </div>\
        <p class="he-age__rsa">By entering this site you agree to our <a href="/policies/terms-of-service">Terms of Service</a>. Liquor Licence LIQW800701813. Must be 18+ to purchase alcohol.</p>\
      </div>';

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    document.getElementById('he-age-yes').addEventListener('click', function() {
      setCookie(COOKIE_NAME, 'yes', COOKIE_DAYS);
      overlay.classList.add('he-age--closing');
      setTimeout(function() {
        overlay.remove();
        document.body.style.overflow = '';
      }, 380);
    });

    document.getElementById('he-age-no').addEventListener('click', function() {
      window.location.href = UNDERAGE_URL;
    });

    // Trap focus inside modal
    var focusable = overlay.querySelectorAll('button, a');
    overlay.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab') return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey) { if (document.activeElement === first) { e.preventDefault(); last.focus(); } }
      else            { if (document.activeElement === last)  { e.preventDefault(); first.focus(); } }
    });
    document.getElementById('he-age-yes').focus();
  }

  // Trigger after 10 seconds
  setTimeout(buildGate, DELAY_MS);
})();
